export default __webpack_public_path__ + "static/media/window.f3751d74.svg";